export const WATCH_DIALOG_LOCATION = {
	PAGE: 0,
	SPACE_OVERVIEW: 1,
	FEED: 2,
	WHITEBOARD: 3,
};
